import { createRoutine } from 'redux-saga-routines'

export const SET = 'PROTAGONISTAS_LAYOUT/SET'
export const CONTENT = createRoutine('PROTAGONISTAS_LAYOUT/CONTENT')
